// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationAfterLogin-headerNavSubListContainer-E0VZC {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 24px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.NavigationAfterLogin-headerMenuItem-NUoF5 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 4px;
    font-size: 16px;
    line-height: 26px;
    font-weight: 400;
    color: var(--primary-foreground);
    padding: 0;
}

.NavigationAfterLogin-headerMenuItem-NUoF5:hover,
.NavigationAfterLogin-headerMenuItem-NUoF5:focus {
    color: var(--primary-foreground);
}

.NavigationAfterLogin-activeTabMenu-BIylU {
    color: var(--primary-link-foreground) !important;
}

@media (max-width: 1199px) {
    .NavigationAfterLogin-headerMenuItem-NUoF5 {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Navigations/NavigationAfterLogin/NavigationAfterLogin.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,SAAS;IACT,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,UAAU;AACd;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".headerNavSubListContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    align-items: flex-start;\n}\n\n.headerMenuItem {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 400;\n    color: var(--primary-foreground);\n    padding: 0;\n}\n\n.headerMenuItem:hover,\n.headerMenuItem:focus {\n    color: var(--primary-foreground);\n}\n\n.activeTabMenu {\n    color: var(--primary-link-foreground) !important;\n}\n\n@media (max-width: 1199px) {\n    .headerMenuItem {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerNavSubListContainer": `NavigationAfterLogin-headerNavSubListContainer-E0VZC`,
	"headerMenuItem": `NavigationAfterLogin-headerMenuItem-NUoF5`,
	"activeTabMenu": `NavigationAfterLogin-activeTabMenu-BIylU`
};
module.exports = ___CSS_LOADER_EXPORT___;
